import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IResourceUOMRepository } from "./IResourceUOMRepository";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { ResourceUOM } from "src/app/models/Production/resource-uom";
import { environment } from "src/environments/environment";
import { ResponseModel } from "src/app/models/SharedModels/response.model";

@Injectable(
    {
        providedIn: "root"
    }
)
export class ResourceUOMRepository extends GenericRepository<ResourceUOM> implements IResourceUOMRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/ResourceUOM', environment.urlAddress);
    }
    GetAll(currentPage: number, recordsPerPage: number): Observable<any> {
        return this.Get('/SelectAll' + '/' + currentPage + '/' + recordsPerPage).pipe(map(this.extractData), catchError(this.handleError));
    }
    SaveRec(item: ResourceUOM): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(code: string): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
}